// extracted by mini-css-extract-plugin
module.exports = {"root":"SignupToEarnBox_root__ChJcE","buttons":"SignupToEarnBox_buttons__ROVms","customRichText":"SignupToEarnBox_customRichText__lku60"};